import TestiLikeComment from "./../components/ui/TestiLikeComment";
import TestiThumb from "./../components/ui/TestiThumb";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';

const allEvents = [
  { lat: 48.8, lng: 2.3, name: 'Paris', country: '🇫🇷', year: 1997, decade: '1990s', concerts: ['HIStory Tour — Bercy 1997', 'Dangerous Tour — Bercy 1992', 'Bad Tour — POPB 1988'] },
  { lat: 51.5, lng: -0.1, name: 'Londres', country: '🇬🇧', year: 1988, decade: '1980s', concerts: ['Bad Tour — Wembley 1988', 'HIStory Tour — Wembley 1997'] },
  { lat: 40.7, lng: -74.0, name: 'New York', country: '🇺🇸', year: 1984, decade: '1980s', concerts: ['Victory Tour — MSG 1984', '30th Anniversary — MSG 2001'] },
  { lat: 34.0, lng: -118.2, name: 'Los Angeles', country: '🇺🇸', year: 1984, decade: '1980s', concerts: ['Thriller Era — Forum 1984', 'Dangerous Tour — Forum 1992'] },
  { lat: 52.5, lng: 13.4, name: 'Berlin', country: '🇩🇪', year: 1988, decade: '1980s', concerts: ['Bad Tour — Deutschlandhalle 1988'] },
  { lat: 35.6, lng: 139.7, name: 'Tokyo', country: '🇯🇵', year: 1987, decade: '1980s', concerts: ['Bad Tour — Tokyo Dome 1987'] },
  { lat: 41.9, lng: 12.5, name: 'Rome', country: '🇮🇹', year: 1997, decade: '1990s', concerts: ['HIStory Tour — Stadio Olimpico 1997'] },
  { lat: 19.4, lng: -99.1, name: 'Mexico', country: '🇲🇽', year: 1993, decade: '1990s', concerts: ['Dangerous Tour — Foro Sol 1993'] },
  { lat: -23.5, lng: -46.6, name: 'São Paulo', country: '🇧🇷', year: 1993, decade: '1990s', concerts: ['Dangerous Tour — Morumbi 1993'] },
  { lat: 48.1, lng: 11.6, name: 'Munich', country: '🇩🇪', year: 1988, decade: '1980s', concerts: ['Bad Tour — Olympiastadion 1988'] },
  { lat: 50.8, lng: 4.4, name: 'Bruxelles', country: '🇧🇪', year: 1997, decade: '1990s', concerts: ['HIStory Tour — Roi Baudouin 1997'] },
  { lat: 40.4, lng: -3.7, name: 'Madrid', country: '🇪🇸', year: 1997, decade: '1990s', concerts: ['HIStory Tour — Vicente Calderón 1997'] },
  { lat: -33.9, lng: 18.4, name: 'Cape Town', country: '🇿🇦', year: 1997, decade: '1990s', concerts: ['HIStory Tour — Green Point 1997'] },
  { lat: 55.7, lng: 37.6, name: 'Moscou', country: '🇷🇺', year: 1996, decade: '1990s', concerts: ['HIStory Tour — Luzhniki 1996'] },
  { lat: 37.5, lng: 127.0, name: 'Séoul', country: '🇰🇷', year: 1992, decade: '1990s', concerts: ['Dangerous Tour — Olympic Stadium 1992'] },
  { lat: -34.6, lng: -58.4, name: 'Buenos Aires', country: '🇦🇷', year: 1993, decade: '1990s', concerts: ['Dangerous Tour — River Plate 1993'] },
];

const decades = {
  '1960s': [1969],
  '1970s': [1972, 1975, 1979],
  '1980s': [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989],
  '1990s': [1992, 1993, 1996, 1997, 1999],
  '2000s': [2001, 2003, 2005, 2009],
};

function latLngToVector3(lat, lng, radius) {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);
  return new THREE.Vector3(
    -radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta)
  );
}

function TestimonialCard({ t, onClick }) {
  return (
    <div onClick={onClick} style={{ padding: '14px 20px', borderBottom: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer', display: 'flex', gap: '12px', alignItems: 'flex-start' }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(139,26,42,0.1)'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
      <TestiThumb t={t} size={58} radius={6} />
      <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
        <span style={{ fontSize: '12px', color: '#fff', fontWeight: '500' }}>{t.authorName}</span>
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)', marginLeft: 'auto', whiteSpace: 'nowrap' }}>
          {t.location?.city} {t.eventDate}
        </span>
      </div>
      {t.authorCountry && (
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', marginBottom: '4px', display: 'block' }}>{t.authorCountry}</span>
      )}
      {t.eventName && (
        <div style={{ display: 'inline-block', fontSize: '12px', background: 'rgba(139,26,42,0.3)', color: '#e8a0a0', padding: '2px 8px', borderRadius: '4px', marginBottom: '7px' }}>{t.eventName}</div>
      )}
      <p style={{
        fontSize: '12px', color: 'rgba(255,255,255,0.55)', lineHeight: '1.6',
        fontStyle: 'italic', fontFamily: 'Georgia,serif',
        overflow: 'hidden', display: '-webkit-box',
        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
      }}>"{t.content}"</p>
      <div style={{ fontSize: '12px', color: '#e8a0a0', marginTop: '5px' }}>Lire la suite →</div>
      </div>
    </div>
  );
}

function TestimonialFull({ t, onClose }) {
  const token = localStorage.getItem('mjtoken');
  const currentUserId = (() => { try { return JSON.parse(atob((token||'').split('.')[1].replace(/-/g,'+').replace(/_/g,'/'))).id; } catch { return undefined; } })();
  return (
    <div>
      <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <button onClick={onClose} style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '10px', display: 'block' }}>← Retour</button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
          <span style={{ fontSize: '15px', color: '#fff', fontWeight: '500' }}>{t.authorName}</span>
        </div>
        {t.authorCountry && (
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', marginBottom: '4px' }}>{t.authorCountry}</div>
        )}
        <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)', marginBottom: '6px' }}>
          {t.location?.city}{t.location?.city && t.eventDate ? ' · ' : ''}{t.eventDate}
        </div>
        {t.eventName && (
          <div style={{ display: 'inline-block', fontSize: '12px', background: 'rgba(139,26,42,0.3)', color: '#e8a0a0', padding: '3px 10px', borderRadius: '4px' }}>{t.eventName}</div>
        )}
      </div>
      <div style={{ padding: '20px' }}>
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: '1.9', fontStyle: 'italic', fontFamily: 'Georgia,serif' }}>"{t.content}"</p>
        {t.photos?.length > 0 && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
            {t.photos.map((p, i) => (
              <img key={i} src={p} alt="" className="lb-img" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid rgba(255,255,255,0.1)' }} />
            ))}
          </div>
        )}
        <TestiLikeComment
          testimonialId={t._id}
          initialLikes={t.likes?.length || 0}
                    likesList={t.likes || []}
          initialComments={t.comments || []}
          currentUserId={currentUserId}
          token={token}
        />
      </div>
    </div>
  );
}

export default function Scene() {
  const mountRef = useRef(null);
  const [selected, setSelected] = useState(null);
  const [hovered, setHovered] = useState(null);
  const [activeDec, setActiveDec] = useState(null);
  const [activeYear, setActiveYear] = useState(null);
  const [openTestimonial, setOpenTestimonial] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [testiLoading, setTestiLoading] = useState(true);
  const isDragging = useRef(false);
  const lastMouse = useRef({ x: 0, y: 0 });
  const autoRotate = useRef(true);

  // Chargement des témoignages MongoDB
  useEffect(() => {
    setTestiLoading(true);
    const params = new URLSearchParams({ section: 'scene' });
    if (activeYear) params.append('year', activeYear);
    fetch('/api/testimonials?' + params.toString())
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setTestimonials(data); })
      .catch(() => {})
      .finally(() => setTestiLoading(false));
  }, [activeYear, activeDec]);

  const filteredEvents = useMemo(() => allEvents.filter(ev => {
    if (activeYear) return ev.year === activeYear;
    if (activeDec) return ev.decade === activeDec;
    return true;
  }), [activeYear, activeDec]);

  useEffect(() => {
    const container = mountRef.current;
    if (!container) return;
    const W = container.clientWidth;
    const H = container.clientHeight;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(36, W / H, 0.1, 1000);
    camera.position.z = 3.4;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(W, H);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0x000000, 0);
    container.appendChild(renderer.domElement);

    const starVerts = [];
    for (let i = 0; i < 3000; i++) starVerts.push((Math.random()-0.5)*100, (Math.random()-0.5)*100, (Math.random()-0.5)*100);
    const starGeo = new THREE.BufferGeometry();
    starGeo.setAttribute('position', new THREE.Float32BufferAttribute(starVerts, 3));
    scene.add(new THREE.Points(starGeo, new THREE.PointsMaterial({ color: 0xffffff, size: 0.06 })));

    const loader = new THREE.TextureLoader();
    const globe = new THREE.Mesh(
      new THREE.SphereGeometry(1, 64, 64),
      new THREE.MeshPhongMaterial({ map: loader.load('/images/earth.jpg'), specular: new THREE.Color(0x222244), shininess: 20 })
    );
    scene.add(globe);

    scene.add(new THREE.Mesh(new THREE.SphereGeometry(1.02, 64, 64), new THREE.MeshPhongMaterial({ color: 0x4488ff, transparent: true, opacity: 0.08, side: THREE.FrontSide })));
    scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    const sun = new THREE.DirectionalLight(0xffffff, 1.4);
    sun.position.set(5, 3, 5);
    scene.add(sun);

    const markers = [];
    const halos = [];
    filteredEvents.forEach((ev) => {
      const pos = latLngToVector3(ev.lat, ev.lng, 1.02);
      const m = new THREE.Mesh(new THREE.SphereGeometry(0.02, 16, 16), new THREE.MeshBasicMaterial({ color: 0xffd060 }));
      m.position.copy(pos);
      m.userData = ev;
      scene.add(m);
      markers.push(m);
      const h = new THREE.Mesh(new THREE.SphereGeometry(0.035, 16, 16), new THREE.MeshBasicMaterial({ color: 0xffd060, transparent: true, opacity: 0.25 }));
      h.position.copy(pos);
      scene.add(h);
      halos.push(h);
    });

    function updateMarkers() {
      markers.forEach((m, i) => {
        const pos = latLngToVector3(filteredEvents[i].lat, filteredEvents[i].lng, 1.02);
        pos.applyEuler(globe.rotation);
        m.position.copy(pos);
        halos[i].position.copy(pos);
      });
    }

    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    function onMouseMove(e) {
      const rect = renderer.domElement.getBoundingClientRect();
      mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      const hits = raycaster.intersectObjects(markers);
      setHovered(hits.length > 0 ? hits[0].object.userData : null);
      renderer.domElement.style.cursor = hits.length > 0 ? 'pointer' : isDragging.current ? 'grabbing' : 'grab';
      if (isDragging.current) {
        globe.rotation.y += (e.clientX - lastMouse.current.x) * 0.005;
        globe.rotation.x += (e.clientY - lastMouse.current.y) * 0.005;
        lastMouse.current = { x: e.clientX, y: e.clientY };
        updateMarkers();
      }
    }

    renderer.domElement.addEventListener('mousemove', onMouseMove);
    renderer.domElement.addEventListener('mousedown', e => { isDragging.current = true; autoRotate.current = false; lastMouse.current = { x: e.clientX, y: e.clientY }; });
    renderer.domElement.addEventListener('mouseup', () => { isDragging.current = false; setTimeout(() => autoRotate.current = true, 3000); });
    renderer.domElement.addEventListener('click', e => {
      const rect = renderer.domElement.getBoundingClientRect();
      mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      const hits = raycaster.intersectObjects(markers);
      if (hits.length > 0) { setSelected(hits[0].object.userData); setOpenTestimonial(null); }
    });
    renderer.domElement.addEventListener('touchstart', e => { isDragging.current = true; autoRotate.current = false; lastMouse.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
    renderer.domElement.addEventListener('touchmove', e => {
      if (!isDragging.current) return;
      globe.rotation.y += (e.touches[0].clientX - lastMouse.current.x) * 0.005;
      globe.rotation.x += (e.touches[0].clientY - lastMouse.current.y) * 0.005;
      lastMouse.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      updateMarkers();
    }, { passive: true });
    renderer.domElement.addEventListener('touchend', () => { isDragging.current = false; setTimeout(() => autoRotate.current = true, 3000); });

    let animId;
    const animate = () => {
      animId = requestAnimationFrame(animate);
      if (autoRotate.current) { globe.rotation.y += 0.003; updateMarkers(); }
      const t = Date.now() / 1000;
      halos.forEach((h, i) => {
        h.material.opacity = 0.1 + Math.sin(t * 2.5 + i) * 0.15;
        h.scale.setScalar(1 + Math.sin(t * 2 + i) * 0.25);
      });
      renderer.render(scene, camera);
    };
    animate();

    return () => {
      cancelAnimationFrame(animId);
      if (container && renderer.domElement.parentNode === container) container.removeChild(renderer.domElement);
      renderer.dispose();
    };
  }, [activeDec, activeYear, filteredEvents]);

  const closeDec = () => { setActiveDec(null); setActiveYear(null); };

  return (
    <div className="scene-grid" style={{ minHeight: '100vh', background: '#020508', display: 'grid', gridTemplateColumns: `80px ${activeDec ? '90px' : '0px'} 1fr 340px`, transition: 'grid-template-columns 0.25s ease' }}>

      {/* FRISE */}
      <div style={{ background: 'rgba(255,255,255,0.03)', borderRight: '1px solid rgba(255,255,255,0.08)', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 6px', overflowY: 'auto', height: '100vh', gap: '4px' }}>
        <div style={{ fontSize: '12px', letterSpacing: '0.1em', color: '#e8a0a0', writingMode: 'vertical-rl', transform: 'rotate(180deg)', marginBottom: '12px' }}>FRISE CHRONOLOGIQUE</div>
        <button onClick={closeDec} style={{ width: '66px', padding: '6px 4px', borderRadius: '8px', border: `1px solid ${!activeDec ? '#e8a0a0' : 'rgba(255,255,255,0.1)'}`, background: 'transparent', color: !activeDec ? '#e8a0a0' : 'rgba(255,255,255,0.4)', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial,sans-serif' }}>Tout</button>
        <div style={{ width: '40px', height: '0.5px', background: 'rgba(255,255,255,0.06)', margin: '5px 0' }} />
        {Object.keys(decades).map((dec, i) => (
          <React.Fragment key={dec}>
            <button onClick={() => { setActiveDec(activeDec === dec ? null : dec); setActiveYear(null); }}
              style={{ width: '66px', padding: '8px 4px', borderRadius: '8px', border: `1px solid ${activeDec === dec ? '#8b1a2a' : 'rgba(255,255,255,0.1)'}`, background: activeDec === dec ? 'rgba(139,26,42,0.5)' : 'transparent', color: activeDec === dec ? '#fff' : 'rgba(255,255,255,0.45)', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial,sans-serif', fontWeight: activeDec === dec ? '500' : '400', textAlign: 'center', lineHeight: '1.4' }}>
              {dec}<span style={{ display: 'block', fontSize: '12px', color: '#e8a0a0', marginTop: '2px' }}>{allEvents.filter(e => e.decade === dec).length}</span>
            </button>
            {i < Object.keys(decades).length - 1 && <div style={{ width: '40px', height: '0.5px', background: 'rgba(255,255,255,0.06)', margin: '4px 0' }} />}
          </React.Fragment>
        ))}
      </div>

      {/* PANNEAU ANNÉES */}
      <div style={{ background: 'rgba(5,2,8,0.97)', borderRight: activeDec ? '1px solid rgba(255,255,255,0.1)' : 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: activeDec ? '16px 6px' : '0', overflowY: 'auto', overflowX: 'hidden', height: '100vh', gap: '3px', transition: 'all 0.25s ease' }}>
        {activeDec && (
          <>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' }}>
              <button onClick={closeDec} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', color: 'rgba(255,255,255,0.4)', borderRadius: '4px', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px' }}>✕</button>
            </div>
            <div style={{ fontSize: '12px', letterSpacing: '0.1em', color: '#e8a0a0', writingMode: 'vertical-rl', transform: 'rotate(180deg)', marginBottom: '10px' }}>{activeDec}</div>
            {decades[activeDec].map(yr => (
              <button key={yr} onClick={() => setActiveYear(activeYear === yr ? null : yr)}
                style={{ width: '66px', padding: '5px 4px', borderRadius: '6px', border: `1px solid ${activeYear === yr ? '#8b1a2a' : 'rgba(255,255,255,0.08)'}`, background: activeYear === yr ? '#8b1a2a' : 'transparent', color: activeYear === yr ? '#fff' : 'rgba(255,255,255,0.4)', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial,sans-serif', textAlign: 'center', lineHeight: '1.4', fontWeight: activeYear === yr ? '500' : '400' }}>
                {yr}<span style={{ display: 'block', fontSize: '12px', color: activeYear === yr ? 'rgba(255,255,255,0.7)' : '#e8a0a0' }}>{allEvents.filter(e => e.year === yr).length}</span>
              </button>
            ))}
          </>
        )}
      </div>

      {/* GLOBE */}
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, padding: '20px 24px', zIndex: 5 }}>
          <p style={{ fontSize: '12px', letterSpacing: '0.15em', color: '#e8a0a0', marginBottom: '4px' }}>— TÉMOIGNAGES</p>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '26px', color: '#fff', fontWeight: '400' }}>📍 Sur scène & sur la route</h1>
        </div>
        {hovered && (
          <div style={{ position: 'absolute', top: '90px', left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,0.85)', border: '1px solid rgba(232,160,160,0.5)', borderRadius: '8px', padding: '10px 18px', pointerEvents: 'none', whiteSpace: 'nowrap', zIndex: 10 }}>
            <div style={{ fontSize: '15px', color: '#fff', fontWeight: '500' }}>{hovered.country} {hovered.name}</div>
            <div style={{ fontSize: '12px', color: '#e8a0a0' }}>{hovered.concerts.length} événement{hovered.concerts.length > 1 ? 's' : ''}</div>
          </div>
        )}
        <div ref={mountRef} className="scene-mount" style={{ width: '100%', height: '100vh' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', pointerEvents: 'none', zIndex: 3 }}>
          <img src="/images/main-gauche.png" alt="" style={{ width: '200px', objectFit: 'contain', transform: 'rotate(-15deg) translateX(-10px) translateY(20px)', filter: 'drop-shadow(0 -8px 30px rgba(0,0,0,0.6))' }} />
          <img src="/images/main-droite.png" alt="" style={{ width: '200px', objectFit: 'contain', transform: 'rotate(15deg) translateX(10px) translateY(20px)', filter: 'drop-shadow(0 -8px 30px rgba(0,0,0,0.6))' }} />
        </div>
        <div style={{ position: 'absolute', bottom: '140px', fontSize: '14px', color: 'rgba(255,255,255,0.25)', letterSpacing: '0.08em', zIndex: 4, left: '50%', transform: 'translateX(-50%)', whiteSpace: 'nowrap', fontFamily: 'Georgia,serif' }}>
          👆 Tournez le globe • Cliquez sur un point doré
        </div>
      </div>

      {/* PANEL DROITE */}
      <div style={{ background: 'rgba(255,255,255,0.03)', borderLeft: '1px solid rgba(255,255,255,0.08)', overflowY: 'auto', height: '100vh' }}>
        {openTestimonial ? (
          <TestimonialFull t={openTestimonial} onClose={() => setOpenTestimonial(null)} />
        ) : selected ? (
          <div>
            <div style={{ padding: '20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <button onClick={() => setSelected(null)} style={{ fontSize: '13px', color: 'rgba(255,255,255,0.35)', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '10px', display: 'block' }}>← Retour</button>
              <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#fff' }}>{selected.country} {selected.name}</h2>
              <p style={{ fontSize: '12px', color: '#e8a0a0', marginTop: '4px' }}>{selected.concerts.length} événement{selected.concerts.length > 1 ? 's' : ''}</p>
            </div>
            {selected.concerts.map((c, i) => (
              <div key={i} style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(139,26,42,0.2)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <div style={{ fontSize: '14px', color: '#fff', fontWeight: '500', marginBottom: '8px' }}>{c}</div>
                <button style={{ fontSize: '12px', color: '#e8a0a0', background: 'transparent', border: '1px solid rgba(232,160,160,0.3)', borderRadius: '5px', padding: '5px 12px', cursor: 'pointer' }}>Voir les témoignages →</button>
              </div>
            ))}
            <div style={{ padding: '16px 20px' }}>
              <button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '13px', fontWeight: '500', cursor: 'pointer', width: '100%' }}>
                ✦ Ajouter mon témoignage pour {selected.name}
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <p style={{ fontSize: '12px', letterSpacing: '0.12em', color: '#e8a0a0', marginBottom: '4px' }}>— DERNIERS TÉMOIGNAGES</p>
              <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>
                {activeDec || activeYear ? `Filtre : ${activeYear || activeDec}` : 'Les plus récents'}
              </p>
            </div>
            {testiLoading && (
              <div style={{ padding: 20, fontSize: 12, color: 'rgba(255,255,255,0.3)', fontStyle: 'italic', textAlign: 'center' }}>Chargement…</div>
            )}
            {!testiLoading && testimonials.length === 0 && (
              <div style={{ padding: 20, fontSize: 12, color: 'rgba(255,255,255,0.3)', fontStyle: 'italic', textAlign: 'center' }}>
                Aucun témoignage{activeYear ? ` pour ${activeYear}` : activeDec ? ` pour les ${activeDec}` : ''} pour l'instant.
              </div>
            )}
            {testimonials.map((t) => (
              <TestimonialCard key={t._id} t={t} onClick={() => setOpenTestimonial(t)} />
            ))}
            {testimonials.length > 0 && (
              <div style={{ padding: '16px 20px', textAlign: 'center' }}>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)', fontStyle: 'italic' }}>{testimonials.length} témoignage{testimonials.length > 1 ? 's' : ''}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
